"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaymentProviderGroup = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _PaymentProviderBox = require("./PaymentProviderBox");
var _jsxRuntime = require("react/jsx-runtime");
const PaymentProviderGroup = (param)=>{
    let { paymentProviderGroup, activeProviderId, isCardDetailsConsent, onPaymentActivation } = param;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    if (paymentProviderGroup.paymentProviders.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...getTestIdProps(_models.TestId.PaymentProviderGroup),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PaymentProviderBox.PaymentProviderBox, {
            activeProviderId: activeProviderId,
            isCardDetailsConsent: isCardDetailsConsent,
            paymentProviderGroup: paymentProviderGroup,
            onPaymentActivation: onPaymentActivation
        })
    });
};
exports.PaymentProviderGroup = PaymentProviderGroup;
